module.exports = {
  BASE_URL: '/api/',
};
